export default function (value, length) {
  if (!value) {
    return ''
  }
  return value.length > length ? value.slice(0, length) + '...' : value
}
